import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class InquiryService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }

  GetInquiry():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/ContactInquiry/Get`);
  }
}
